import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-title" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = {
  key: 0,
  class: "modal-card-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-background",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
          "aria-label": "close"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("button", {
              class: "delete",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
              "aria-label": "close"
            })
          ]),
          _createElementVNode("section", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}